var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"isQuestion":false,"confirm-title":"account.logout","buttonConfirmTitle":_vm.btnText,"secondTitle":"auth.modal_secondary_text","description":"auth.are_you_sure_you_want_to_log_out"},on:{"confirm":_vm.logout,"cancel":function($event){return _vm.$emit('closeModalLogout')}}},[_c('icon-logout',{attrs:{"size":80}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }